var translation = {
	Navatar: {
		header: "Profil AWS",
		subheader: "Profil Anda membantu meningkatkan interaksi dengan pengalaman AWS tertentu.",
		profileButtonText: "Lihat profil",
		logOutText: "Keluar",
		logInText: "Masuk",
		createProfileText: "Buat profil",
		federateLoginModalTitle: "Menggunakan Midway untuk Mengakses Profil AWS Anda",
		federateLoginModalFirstDescription: "Sebagai karyawan Amazon, kami merekomendasikan Anda menggunakan Midway untuk mengakses Profil AWS Anda. Metode yang direkomendasikan keamanan ini menyediakan integrasi yang mulus dengan sistem internal.",
		federateLoginModalSecondDescription: "Anda melihat pesan ini karena Anda telah masuk dengan alamat email Amazon menggunakan ID AWS Builder. Prompt ini akan muncul setiap kali Anda masuk hingga Anda beralih ke Midway atau memilih untuk melanjutkan dengan login Anda saat ini.",
		federateLoginModalPrimaryButton: "Masuk dengan Midway",
		federateLoginModalSecondaryButton: "Melanjutkan dengan ID AWS Builder"
	}
};
var Navatar = {
	translation: translation
};

export { Navatar as default, translation };
